export default "__VITE_ASSET__wda2ymHK__"